import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserpilotReloader } from '../../../helper/userpilot-reloader.component';

declare var localStorage: Storage;

@Component({
  selector: 'app-email-template-dialog',
  templateUrl: './email-template-dialog.component.html',
  styleUrls: [
    './email-template-dialog.component.scss',
  ]
})
export class EmailTemplateDialogComponent extends UserpilotReloader {

  emailTemplate: string;
  showClearTemplate = false;

  emailSignature: string = 'your anessa team';
  showClearSignature = false;

  constructor(
    private dialogRef: MatDialogRef<EmailTemplateDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: { emailTemplate: string, emailSignature: string },
  ) {
    super();
    if (this.data) {
      this.emailTemplate = this.data.emailTemplate;
      if (this.data.emailSignature) {
        this.emailSignature = this.data.emailSignature;
      }
    }
  }

  clearTemplate() {
    this.emailTemplate = '';
  }

  clearSignature() {
    this.emailSignature = '';
  }

  onCancel() {
    this.dialogRef.close(null);
  }

  onSend() {
    this.dialogRef.close({ template: this.emailTemplate, signature: this.emailSignature });
  }
}
